import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateShift($companyId: ID!, $id: ID!, $attributes: ShiftAttributes!) {
    updateShift(companyId: $companyId, id: $id, attributes: $attributes) {
      shift {
        id
        ...UpdatedShift
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedShift on Shift {
    id
    user { id displayName }
    start
    finish
    rateCents
    shiftRole { id name }
  }
`
